import React, { useEffect } from 'react';
import { motion } from 'framer-motion';

// ═══════════════════════════════════════════════════════════════
// PLAYER TURN TRANSITION (HOT-SEAT PRIVACY SCREEN)
// ═══════════════════════════════════════════════════════════════

interface PlayerTurnTransitionProps {
  playerName: string;
  playerColor: string;
  roundNumber: number;
  isAI: boolean;
  onConfirm: () => void;
}

export const PlayerTurnTransition: React.FC<PlayerTurnTransitionProps> = ({
  playerName,
  playerColor,
  roundNumber,
  isAI,
  onConfirm,
}) => {
  // Auto-confirm for AI players
  useEffect(() => {
    if (isAI) {
      const timer = setTimeout(() => {
        onConfirm();
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [isAI, onConfirm]);

  if (isAI) {
    return (
      <div className="bs-transition">
        <motion.div
          className="bs-transition-shield"
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.3 }}
        >
          <div className="bs-anchor-icon">&#9875;</div>
          <p className="bs-transition-text">Round {roundNumber}</p>
          <h2 className="bs-transition-name" style={{ color: playerColor }}>
            {playerName}
          </h2>
          <p className="bs-flavor-text">is taking their turn...</p>
          <motion.div
            animate={{ rotate: 360 }}
            transition={{ duration: 2, repeat: Infinity, ease: 'linear' }}
            style={{ fontSize: '2rem' }}
          >
            &#9881;
          </motion.div>
        </motion.div>
      </div>
    );
  }

  return (
    <div className="bs-transition">
      <motion.div
        className="bs-transition-shield"
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.3 }}
      >
        <div className="bs-anchor-icon">&#9875;</div>
        <p className="bs-transition-text">Round {roundNumber}</p>
        <p className="bs-transition-text">Pass the device to</p>
        <h2 className="bs-transition-name" style={{ color: playerColor }}>
          {playerName}
        </h2>
        <p className="bs-privacy-warning">
          Other players: Look away while dice are revealed!
        </p>

        <motion.button
          className="bs-btn bs-btn-primary bs-btn-large"
          onClick={onConfirm}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          I am {playerName} - Begin Voyage
        </motion.button>
      </motion.div>
    </div>
  );
};

export default PlayerTurnTransition;
